/**
 * P0 · Feb 2026 — /api/submissions/my response normalizer.
 *
 * ``GET /api/submissions/my`` was migrated to a paginated envelope
 * ``{ items, total, has_more, next_cursor, limit }``. The pre-Patch-A
 * shape was a raw array. This normalizer accepts BOTH shapes plus
 * every malformed edge (null / undefined / non-array ``items`` key)
 * and always returns an array, so ``items.map(...)`` at render time
 * cannot crash the whole Contest Entry screen with
 * ``o.map is not a function``.
 *
 * Kept in its own module so the targeted unit test can exercise it
 * without pulling the full Contest Entry page (react-router, shadcn,
 * etc.) into the jest module graph.
 */
export const normalizeSubmissionsList = (raw) => {
  if (Array.isArray(raw)) return raw;
  if (raw && Array.isArray(raw.items)) return raw.items;
  return [];
};
